'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  venues: {
    empty: 'No venue found.',
    new: 'Add new venue',
    title: 'Venues',
    addVenue: 'Add venue',
    next: 'Next page',
    previous: 'Previous page',
    sortDirection: {
      asc: 'Ascending',
      desc: 'Descending'
    },
    sortOrder: {
      name: 'Name',
      creation: 'creation date',
      modification: 'modification date',
      created_at: 'created at',
      updated_at: 'modified at'
    },
    form: {
      address2: 'Address (2nd line)',
      address: 'Address',
      businessHours: 'Business hours',
      cc_id: 'ID Culture Creates',
      city: 'City',
      confirmSave: 'Do you want to save the changes made in this venue\xA0?',
      country: 'Country',
      dontSave: 'Do not save',
      latitude: 'Latitude',
      lockLatLon: 'Specify the values for lat. / long.',
      longitude: 'Longitude',
      name: 'Venue name',
      otherNames: {
        label: 'Other names',
        placeholder: 'One per line'
      },
      phone: 'Telephone',
      postalCode: 'Postal code',
      save: 'Save',
      state: 'Province',
      website: 'Website'
    },
    total: '%{smart_count} venue ordered by |||| %{smart_count} venues ordered by'
  },
  events: { // FIXME: Should probably refactor this
    groupsBox: {
      add: 'Add organizations:',
      groupAlreadyExists: 'This organizations already exists',
      help: 'Type something to search',
      noResults: 'No results.',
      title: 'Owner Organizations',
      typeSome: 'Type to search...'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/venues.js
// module id = 2289
// module chunks = 0